export const MAIN_TIME_OPTIONS = Object.freeze([
  { value: 60_000, label: '1 分钟' },
  { value: 300_000, label: '5 分钟' },
  { value: 600_000, label: '10 分钟' },
  { value: 900_000, label: '15 分钟' },
  { value: 1_200_000, label: '20 分钟' },
  { value: 1_800_000, label: '30 分钟' },
  { value: 3_600_000, label: '60 分钟' },
  { value: 7_200_000, label: '120 分钟' },
] as const);
